export default __webpack_public_path__ + "static/media/Surprise.34c75517.png";